import React from 'react'

import { i18n } from '@localization'
import { Icon } from '@zet/design-system/icons'
import { Stack, XStack, YStack } from '@zet/design-system/layout'
import { B2, B5, SH3 } from '@zet/design-system/typography'
import Salaried from '@zet/svg/salaried'
import SelfEmployed from '@zet/svg/selfEmployed'
import { ScrollView } from 'react-native-gesture-handler'

type DocumentsRequiredType = {
  heading: string
  content: string
}

type EligibilityCardType = {
  type: string
  ageGroup?: string
  incomeRange?: string
  documentsRequired: Array<DocumentsRequiredType>
}

export const EligibilityCard = ({
  type,
  ageGroup,
  incomeRange,
  documentsRequired,
}: EligibilityCardType) => {
  if (
    !(
      ageGroup ||
      incomeRange ||
      (documentsRequired?.length > 0 && documentsRequired[0] !== undefined)
    )
  ) {
    return <></>
  }

  return (
    <>
      {ageGroup ||
      incomeRange ||
      (documentsRequired?.length > 0 &&
        documentsRequired[0].content !== undefined) ? (
        <Stack className="bg-neutral-white100 mb-2 p-3">
          <XStack className="mb-4/2 items-center space-x-3">
            {type?.trim()?.toLowerCase() === 'salaried' ? (
              <Salaried />
            ) : (
              <SelfEmployed />
            )}
            <SH3 className="text-grays-100">
              {type?.trim()?.toLowerCase() === 'salaried'
                ? i18n.t('eligibilityCriteria.salaried')
                : i18n.t('eligibilityCriteria.selfEmployed')}
            </SH3>
          </XStack>
          <YStack className="space-y-2">
            {ageGroup && (
              <XStack className="bg-grays-20 items-center space-x-3 rounded-t-lg px-2 py-3">
                <Stack className="rounded bg-white p-[2]">
                  <Icon type="LeadsOutlined" size={30} color={'#75ACFF'} />
                </Stack>
                <YStack>
                  <B2 className="text-grays-60">
                    {i18n.t('eligibilityCriteria.ageGroup')}
                  </B2>
                  <SH3 className="flex-1 flex-wrap pr-3">{ageGroup}</SH3>
                </YStack>
              </XStack>
            )}
            {incomeRange && (
              <XStack className="bg-grays-20 items-center rounded-b-lg px-2 py-3">
                <Stack className="rounded bg-white p-[2]">
                  <Icon type="MoneyBagOutlined" size={30} color={'#15BA8B'} />
                </Stack>
                <YStack className="flex-1 pl-3">
                  <B2 className="text-grays-60">
                    {i18n.t('eligibilityCriteria.incomeRange')}
                  </B2>
                  <SH3 className="mr-3 flex-1">{incomeRange}</SH3>
                </YStack>
              </XStack>
            )}
          </YStack>
          {documentsRequired?.length > 0 &&
          documentsRequired[0].content !== undefined ? (
            <Stack className="py-3">
              <B2 className="mb-2">
                {i18n.t('eligibilityCriteria.documentsRequired')}
              </B2>
              <ScrollView
                horizontal={true}
                showsHorizontalScrollIndicator={false}
                className="space-x-2"
              >
                {documentsRequired.map((element) => (
                  <React.Fragment key={JSON.stringify(element)}>
                    {element && element.content !== undefined ? (
                      <Stack className="border-grays-20 w-40 rounded-md border px-2 py-2">
                        <SH3 className="text-grays-100">{element.heading}</SH3>
                        <B5 className="text-grays-60 text-left">
                          {element.content}
                        </B5>
                      </Stack>
                    ) : (
                      <></>
                    )}
                  </React.Fragment>
                ))}
              </ScrollView>
            </Stack>
          ) : (
            <></>
          )}
        </Stack>
      ) : (
        <></>
      )}
    </>
  )
}
